import { lazy } from "react";
import ReportsMenu from "../components/ReportsMenu/ReportsMenu";
import IncomePage from "../pages/IncomePage/IncomePage";
import ListReturnOnSale from "../pages/ReturnSales/ListReturnSale/ListReturnSale";

const Orders = lazy(() => import("../pages/Orders/Orders"));
const ApproveOrderOnline = lazy(() =>
  import("../pages/ApproveOrderOnline/ApproveOrderOnline")
);
const PaymentOrderOnline = lazy(() =>
  import("../pages/PaymentOrderOnline/PaymentOrderOnline")
);
const DeliverOrderOnline = lazy(() =>
  import("../pages/DeliverOrderOnline/DeliverOrderOnline")
);
const CustomerOrderOnlineWait = lazy(() =>
  import("../pages/CustomerOrderOnlineWait/CustomerOrderOnlineWait")
);
const CustomerOrderOnlineDone = lazy(() =>
  import("../pages/CustomerOrderOnlineDone/CustomerOrderOnlineDone")
);
const OrderDetail = lazy(() =>
  import("../pages/Orders/OrderDetail/OrderDetail")
);
const DashboardAccounting = lazy(() =>
  import("../pages/DashboardAccounting/DashboardAccounting")
);
const OrdersItem = lazy(() => import("../pages/Orders/OrdersItem/OrdersItem"));
const BaseInfo = lazy(() => import("../pages/BaseInfo/BaseInfo"));
const PersonalInfo = lazy(() => import("../pages/PersonalInfo/PersonalInfo"));
const PersonalInfoDetail = lazy(() =>
  import("../pages/PersonalInfoDetail/PersonalInfoDetail")
);
const CheckDesk = lazy(() => import("../pages/CheckDesk/CheckDesk"));
const Banks = lazy(() => import("../pages/Banks/Banks"));
const InvoicePage = lazy(() => import("../pages/Invoice/Invoice"));
const SaleInvoicePage = lazy(() =>
  import("../pages/SaleInvoicePage/SaleInvoicePage")
);
const ChecksPage = lazy(() => import("../pages/Checks/ChecksPage"));
const FactorsPage = lazy(() => import("../pages/FactorsPage/FactorsPage"));
const GetDocumentPage = lazy(() =>
  import("../pages/GetDocumentPage/GetDocumentPage")
);
const ListFactorPage = lazy(() =>
  import("../pages/ListFactorPage/ListFactorPage")
);
const SiteOrders = lazy(() => import("../pages/SiteOrders/SiteOrders"));
const AnbarPage = lazy(() => import("../pages/AnbarPage/AnbarPage"));
const CostsPage = lazy(() => import("../pages/CostsPage/CostsPage"));
const ReturnSlates = lazy(() => import("../pages/ReturnSales/ReturnSales"));
const PaymentOperation = lazy(() =>
  import("../pages/purchase-invoice/purchaseInvoice")
);
const PurchaseDocument = lazy(() =>
  import("../pages/purchase-invoice/PurchaseDocument/PurchaseDocument")
);
const PayementSell = lazy(() => import("../pages/PayementSell/PayementSell"));

const PaymentListOperation = lazy(() =>
  import("../pages/PaymentListOperation/PaymentListOperation")
);

const ReceiveOperation = lazy(() =>
  import("../pages/ReceiveOperation/ReceiveOperation")
);

const PaymentOperations = lazy(() =>
  import("../pages/PaymentOperation/PaymentOperations")
);

const ListFactorPurchase = lazy(() =>
  import("../pages/ListFactorPurchase/ListFactorPurchase")
);

const PaymentCheck = lazy(() => import("../pages/PaymenrCheck/PaymenrCheck"));

const ListSellCheck = lazy(() =>
  import("../pages/ListSellCheck/ListSellCheck")
);

const HavaleHesab = lazy(() => import("../pages/HavaleHesab/HavaleHesab"));

export const AccountantRoute = [
  {
    path: "/dashboard",
    className: "dashboard",
    component: <DashboardAccounting />,
  },
  {
    path: "/orders",
    className: "orders",
    component: <OrdersItem />,
  },
  {
    path: "/orders/all",
    className: "orders-all",
    component: <Orders />,
  },
  {
    path: "/orders/all/:idOrderOnline",
    className: "orders-all-:idOrderOnline",
    component: <OrderDetail />,
  },
  {
    path: "/orders/invoice",
    className: "orders-invoice",
    component: <InvoicePage />,
  },
  {
    path: "/orders/sales-invoice",
    className: "orders-sales-invoice",
    component: <SaleInvoicePage />,
  },
  {
    path: "/orders/factors",
    className: "orders-factors",
    component: <FactorsPage />,
  },
  {
    path: "/orders/list-factor",
    className: "orders-list-factor",
    component: <ListFactorPage />,
  },
  {
    path: "/orders/factors/:IdEquivalentOrder",
    className: "orders-factors-:IdEquivalentOrder",
    component: <GetDocumentPage />,
  },
  {
    path: "/notApprovedOrderOnline",
    className: "notApprovedOrderOnline",
    component: <ApproveOrderOnline />,
  },
  {
    path: "/notPaymentOrderOnline",
    className: "notPaymentOrderOnline",
    component: <PaymentOrderOnline />,
  },
  {
    path: "/toDeliverOrderOnline",
    className: "toDeliverOrderOnline",
    component: <DeliverOrderOnline />,
  },

  {
    path: "/notOkayCustomerOrderOnline",
    className: "notOkayCustomerOrderOnline",
    component: <CustomerOrderOnlineWait />,
  },
  {
    path: "/okayCustomerOrderOnline",
    className: "okayCustomerOrderOnline",
    component: <CustomerOrderOnlineDone />,
  },
  {
    path: "/baseInfo",
    className: "baseInfo",
    component: <BaseInfo />,
  },
  {
    path: "/baseInfo/personInfo",
    className: "baseInfo-personInfo",
    component: <PersonalInfo />,
  },
  {
    path: "/baseInfo/personInfo/:IdPerson",
    className: "baseInfo-personInfo",
    component: <PersonalInfoDetail />,
  },
  {
    path: "/baseInfo/cach-desk",
    className: "baseInfo-cach-desk",
    component: <CheckDesk />,
  },
  {
    path: "/baseInfo/banks",
    className: "baseInfo-banks",
    component: <Banks />,
  },
  {
    path: "/baseInfo/checks",
    className: "baseInfo-checks",
    component: <ChecksPage />,
  },
  {
    path: "/baseInfo/payment-check",
    className: "baseInfo-payment-check",
    component: <PaymentCheck />,
  },
  {
    path: "/baseInfo/addAnbar",
    className: "baseInfo-anbar",
    component: <AnbarPage />,
  },
  {
    path: "/baseInfo/costs",
    className: "baseInfo-costs",
    component: <CostsPage />,
  },
  {
    path: "/baseInfo/income",
    className: "baseInfo-income",
    component: <IncomePage />,
  },

  {
    path: "/siteOrders",
    className: "siteOrders",
    component: <SiteOrders />,
  },
  {
    path: "/orders/return-sales",
    className: "return-sales",
    component: <ReturnSlates />,
  },
  {
    path: "/orders/list-return-sales",
    className: "return-sales",
    component: <ListReturnOnSale />,
  },
  {
    path: "/orders/purchase-invoice",
    className: "payment-operation",
    component: <PaymentOperation />,
  },
  {
    path: "/orders/purchase-invoice/:id",
    className: "payment-operation",
    component: <PurchaseDocument />,
  },
  {
    path: "/reports",
    className: "reports-menu",
    component: <ReportsMenu />,
  },
  {
    path: "/reports/cash-desk",
    className: "reports-cash-desk",
    component: <CheckDesk reports={true} />,
  },
  {
    path: "/reports/banks",
    className: "reports-banks",
    component: <Banks reports={true} />,
  },
  {
    path: "/reports/checksReceived",
    className: "reports-checks",
    component: <ChecksPage reports={true} />,
  },
  {
    path: "/reports/checksPaid",
    className: "reports-checks",
    component: <ChecksPage reports={true} paid={true} />,
  },
  {
    path: "/reports/income",
    className: "reports-income",
    component: <IncomePage reports={true} />,
  },
  {
    path: "/reports/costs",
    className: "reports-costs",
    component: <CostsPage reports={true} />,
  },
  {
    path: "/reports/personInfo",
    className: "baseInfo-personInfo",
    component: <PersonalInfo reports={true} />,
  },
  {
    path: "/orders/get-operation-list",
    className: "payment-operation",
    component: <PayementSell />,
  },
  {
    path: "/orders/list-payment-operation",
    className: "payment-operation",
    component: <PaymentListOperation />,
  },
  {
    path: "/orders/receive-operation",
    className: "receive-operation",
    component: <ReceiveOperation />,
  },
  {
    path: "/orders/payment-operation",
    className: "receive-operation",
    component: <PaymentOperations />,
  },
  {
    path: "/orders/list-purchase-invoice",
    className: "list-purchase-invoice",
    component: <ListFactorPurchase />,
  },
  {
    path: "/baseInfo/list-sell-check",
    className: "list-sell-check",
    component: <ListSellCheck paid={true} />,
  },
  {
    path: "/orders/havale-hesab",
    className: "list-sell-check",
    component: <HavaleHesab />,
  },
];
